import React from 'react';
import css from './FlipAndWinCards.css';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { cardAlreadyFlipped } from './helpers';
import CardContentNonFlipped from './CardFrontSide';
import CardBackSide from './CardBackSide';

export const FlipAndWinCards = ({ cards, ...rest }) => {
    const currentUser = useSelector(state => state.user.currentUser);

    const { flipAndWinData } = currentUser?.attributes?.profile?.privateData || {};
    const { cardsFlipped } = flipAndWinData || {
        cardsFlipped: {},
    };

    const cardsReordered = new Array(cards?.length || 0).fill(null);
    const unallocatedCards = [];

    (cards || []).forEach(card => {
        const cardId = card?.id;
        const cardIsFlipped = cardAlreadyFlipped(card, cardsFlipped);
        const flippedCardIndex = cardIsFlipped ? cardsFlipped[cardId].flippedCardIndex : undefined;

        if (typeof flippedCardIndex === 'number' && cardIsFlipped) {
            cardsReordered[flippedCardIndex] = card;
        } else {
            unallocatedCards.push(card);
        }
    });

    const finalCards = cardsReordered.map(slot =>
        slot !== null ? slot : unallocatedCards.shift()
    );

    return (
        <div className={css.flipAndWinCardsHolder}>
            {finalCards.map((card, index) => (
                <div key={card.id || index} className={css.flipAndWinCardsWrapper}>
                    <div
                        className={classNames(css.flipAndWinCardsItem, {
                            [css.flipped]: cardAlreadyFlipped(card, cardsFlipped) || '',
                        })}
                    >
                        <CardContentNonFlipped
                            cardIndex={index}
                            currentUser={currentUser}
                            card={card}
                            {...rest}
                        />
                        <CardBackSide card={card} currentUser={currentUser} />
                    </div>
                </div>
            ))}
        </div>
    );
};
